"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOvertimePreviewStartDto = instanceOfOvertimePreviewStartDto;
exports.OvertimePreviewStartDtoFromJSON = OvertimePreviewStartDtoFromJSON;
exports.OvertimePreviewStartDtoFromJSONTyped = OvertimePreviewStartDtoFromJSONTyped;
exports.OvertimePreviewStartDtoToJSON = OvertimePreviewStartDtoToJSON;
exports.OvertimePreviewStartDtoToJSONTyped = OvertimePreviewStartDtoToJSONTyped;
const OvertimePreviewSkippedCheckDto_1 = require("./OvertimePreviewSkippedCheckDto");
/**
 * Check if a given object implements the OvertimePreviewStartDto interface.
 */
function instanceOfOvertimePreviewStartDto(value) {
    if (!('jobId' in value) || value['jobId'] === undefined)
        return false;
    if (!('previewedCheckCount' in value) || value['previewedCheckCount'] === undefined)
        return false;
    if (!('skippedChecks' in value) || value['skippedChecks'] === undefined)
        return false;
    return true;
}
function OvertimePreviewStartDtoFromJSON(json) {
    return OvertimePreviewStartDtoFromJSONTyped(json, false);
}
function OvertimePreviewStartDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jobId': json['jobId'],
        'previewedCheckCount': json['previewedCheckCount'],
        'skippedChecks': (json['skippedChecks'].map(OvertimePreviewSkippedCheckDto_1.OvertimePreviewSkippedCheckDtoFromJSON)),
    };
}
function OvertimePreviewStartDtoToJSON(json) {
    return OvertimePreviewStartDtoToJSONTyped(json, false);
}
function OvertimePreviewStartDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jobId': value['jobId'],
        'previewedCheckCount': value['previewedCheckCount'],
        'skippedChecks': (value['skippedChecks'].map(OvertimePreviewSkippedCheckDto_1.OvertimePreviewSkippedCheckDtoToJSON)),
    };
}
//# sourceMappingURL=OvertimePreviewStartDto.js.map